// @ngInject
function BudgetsApiService($q, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = "budgets";

    return {
        getSalesBudgets: getSalesBudgets,
        getBudgetsForItemGroupAndCollection: getBudgetsForItemGroupAndCollection,
        getBudgetForItemGroupLocationAndCollection: getBudgetForItemGroupLocationAndCollection,
        getBudgetForCollection: getBudgetForCollection,
        getBudgetsForCompany: getBudgetsForCompany,
        importBudgets: ResourcesService.apiFactory.save(endpoint + '/salesbudgets/import')
    };

    function getSalesBudgets(page, filter, pageSize) {

        var params = {
            filter: '',
            page: 1,
            pageSize: 20
        };

        if (page && page > 1) {
            params.page = page;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.filter = filter;
        }

        var args = { params: params };

        return ResourcesService.apiFactory.get(endpoint + '/sales')(args);
    }

    function getBudgetsForItemGroupAndCollection(itemGroupId, collectionId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'budgets/itemgroup/' + itemGroupId + '/collection/' + collectionId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getBudgetForItemGroupLocationAndCollection(itemGroupId, locationId, collectionId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'budgets/itemgroup/' + itemGroupId + '/location/' + locationId + '/collection/' + collectionId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getBudgetForCollection(collectionId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'budgets/collection/' + collectionId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getBudgetsForCompany(companyId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'budgets/company/' + companyId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular.module('budgets.api', [])
    .factory('BudgetsApiService', BudgetsApiService);
